export const ALL_GRANULARITY = 'all' as const;
export const DAY_GRANULARITY = 'day' as const;
export const WEEK_GRANULARITY = 'week' as const;
export const MONTH_GRANULARITY = 'month' as const;
